var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaHideIconType31(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75,
    r: 61,
    stroke: "white",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5896 109.017L59.0052 95.6797C56.8581 93.5716 58.3781 89.9667 61.4158 89.9667H67.7298V43.3461C67.7298 41.4991 69.2566 40 71.1378 40H78.8627C80.7439 40 82.2707 41.4991 82.2707 43.3461V89.9689H88.5847C91.6201 89.9689 93.1423 93.5738 90.9953 95.6819L77.4109 109.02C76.0795 110.327 73.921 110.327 72.5919 109.02L72.5896 109.017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaHideIconType31);
export default __webpack_public_path__ + "static/media/aioa-hide-icon-type-31.9ff8ec485946e747e1f74ff39c02d46c.svg";
export { ForwardRef as ReactComponent };